
// import {
//     ListViewProvider,
//     useListView,
// } from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
// import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
// import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
// import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
// import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
// import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
// import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
// // import {roleColumns} from './_columns'
// // import { roleColumns } from './_columnsC'
// import { roleColumns } from './_columnsComit'
// import { initialQueryState } from '../../../../../../_metronic/helpers'
// import { useEffect, useState } from 'react'
// import { useQuery } from 'react-query'
// import { getUserById } from '../../../data-administration/data-admininstration-list/core/_requests'
// import { useQueryRequest } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
// import { CardsWidget20 } from '../../../../../../_metronic/partials/widgets';
// import { CardsWidget7 } from '../../../../../../_metronic/partials/widgets';
// import { CardsWidget17 } from '../../../../../../_metronic/partials/widgets';
// import { CardsWidget18 } from '../../../../../../_metronic/partials/widgets/_new/cards/CardsWidget18'
// import { FeedsWidget6 } from '../../../../../../_metronic/partials/widgets';
// import { toAbsoluteUrl } from '../../../../../../_metronic/helpers';
// import { MixedWidget10CS } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget10Sponsor'
// import { ChartsWidgetG2 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidgetG2'
// import { TablesWidget9 } from '../../../../../../_metronic/partials/widgets'

// const QualityList = () => {
//     const { data } = useQuery(
//         `clients/101212/categories`,
//         () => getUserById('', 'clients/101212/categories'),
//         {
//             cacheTime: 0,
//             onError: (err) => {
//                 console.warn(err)
//             },
//         }
//     )
//     const { updateState } = useQueryRequest()

//     // const [categoriesList, setCategoriesList] = useState([{label: 'Select one', value: ''}])
//     // useEffect(() => {
//     //   if (data && data.length) {
//     //     let dropdownData: any = []
//     //     data.map((eachData) => {
//     //       return dropdownData.push({label: eachData.name, value: eachData.id})
//     //     })
//     //     setCategoriesList(dropdownData)
//     //     updateState({
//     //       enabled: true,
//     //       initialApi: `categories/${dropdownData[0].value}/price`,
//     //       ...initialQueryState,
//     //     })
//     //   }
//     // }, [data])

//     // const searchElements = [
//     //   {
//     //     type: 'select',
//     //     queryType: 'price',
//     //     value: 'select',
//     //     options: categoriesList,
//     //   },
//     // ]

//     return (
//         <KTCard>
//             <div style={{padding:"25px"}}>
//                 <div className='row g-5 g-xl-10 d-flex align-items-stretch'>
//                     <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex'>
//                         <CardsWidget20
//                             className='flex-fill'
//                             description={"Purchase Orders"}
//                             color='#F1416C'
//                             data={0}
//                             img={toAbsoluteUrl('/media/patterns/vector-1.png')}
//                         />
//                     </div>
//                     <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex'>
//                         <CardsWidget7
//                             className='flex-fill'
//                             description='Lives Impacted'
//                             icon={false}
//                             stats={0}
//                             labelColor='dark'
//                             textColor='gray-300'
//                         />
//                     </div>
//                     <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 d-flex'>
//                         <CardsWidget18
//                             className="flex-fill"
//                             collectionValue={"0"}
//                             recyclingValue={"0"}
//                             collection={0}
//                             recycling={0}
//                         />
//                     </div>
//                 </div>
//                 <div className="row" style={{ marginTop: "30px" }}>
//                     <div className="col-4">
//                         <MixedWidget10CS
//                             className='card-xl-stretch mb-xl-8'
//                             chartColor='info'
//                             chartHeight='150px'
//                             title="Commitment Created"
//                             subtitle="Quantity collected from waste suppliers"
//                             amount="0"
//                             chartData={{}}
//                         />
//                     </div>
//                     <div className="col-4">
//                         <MixedWidget10CS
//                             className='card-xl-stretch mb-xl-8'
//                             chartColor='warning'
//                             chartHeight='150px'
//                             title="Commitment Fullfilled"
//                             subtitle="Quantity converted into recycled products"
//                             amount="0"
//                             chartData={{}}
//                         />
//                     </div>
//                     <div className="col-4">
//                         <ChartsWidgetG2
//                             className="mb-5"
//                             label=""
//                             data={{ category1: 100, category2: 200, category3: 150 }}
//                         />
//                     </div>
//                 </div>
//                 <TablesWidget9 className='' data={{}} />
//             </div>
//             <UsersListHeader label='Add new' placeholder='Search' />
//             <UsersTable columnProps={roleColumns} />
//             <UserEditModal formName='CommitmentForm' />
//         </KTCard>
//     )
// }

// const CreateComit = () => (
//     // <QueryRequestProvider initialValue={{enabled: false}}>
//     <QueryRequestProvider initialValue={{ initialApi: 'commitments' }}>
//         <QueryResponseProvider>
//             <ListViewProvider>
//                 <QualityList />
//             </ListViewProvider>
//         </QueryResponseProvider>
//     </QueryRequestProvider>
// )

// export { CreateComit }













import {
    ListViewProvider,
    useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
import { roleColumns } from './_columnsComit'
import { initialQueryState } from '../../../../../../_metronic/helpers'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../../../data-administration/data-admininstration-list/core/_requests'
import { useQueryRequest } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { CardsWidget20, ListsWidget2 } from '../../../../../../_metronic/partials/widgets';
import { CardsWidget7 } from '../../../../../../_metronic/partials/widgets';
import { CardsWidget17 } from '../../../../../../_metronic/partials/widgets';
import { CardsWidget18 } from '../../../../../../_metronic/partials/widgets/_new/cards/CardsWidget18'
import { FeedsWidget6 } from '../../../../../../_metronic/partials/widgets';
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers';
import { MixedWidget10CS } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget10Sponsor'
import { MixedWidget103 } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget103'
import { ChartsWidgetG2 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidgetG2'
import { TablesWidget9 } from '../../../../../../_metronic/partials/widgets'
import CommitmentForm1 from '../../../data-administration/data-admininstration-list/form-edit-modal/CommitmentForm'
import { useNavigate } from 'react-router-dom'
import { ChartsWidget9C1 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidget9C1'
import { ChartsWidget14 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidget14'
import MetricCards, {
    ProjectsIcon,
    ChartIcon,
    StockIcon,
    LocationIcon,
    PercentIcon,
    SaveIcon
} from './MetricCards';
import { useAuth } from '../../../../auth'

const QualityList = () => {
    const [analyticsData, setAnalyticsData] = useState<any>(null)
    const { currentUser, }: any = useAuth()

    const navigate = useNavigate()
    // const [analyticsData, setAnalyticsData] = useState<any>(null)

    const { data } = useQuery(
        `clients/101212/categories`,
        () => getUserById('', 'clients/101212/categories'),
        {
            cacheTime: 0,
            onError: (err) => {
                console.warn(err)
            },
        }
    )
    const { updateState } = useQueryRequest()

    useEffect(() => {
        const fetchCommitmentAnalytics = async () => {
            try {
                const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')
                const token = authData?.data?.token

                const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}commitments/analytics`, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json'
                    }
                })

                if (response.ok) {
                    const data = await response.json()
                    console.log('Commitment Analytics Response:', data)
                    setAnalyticsData(data)
                } else {
                    console.error('API call failed:', response.status, response.statusText)
                }
            } catch (error) {
                console.error('Error fetching commitment analytics:', error)
            }
        }

        fetchCommitmentAnalytics()
    }, [])

    const voucherTypeData = Object.entries(analyticsData?.sponsorsPerMembershipTier || {}).map(([key, value]) => ({
        name: key,
        value: value
    }))

    return (
        <KTCard>
            {/* <div style={{ padding: "25px" }}>
                <div className='row g-5 g-xl-10 d-flex align-items-stretch'>
                    <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex'>
                        <CardsWidget20
                            className='flex-fill'
                            description={"Purchase Orders"}
                            color='#F1416C'
                            data={analyticsData?.commitments || 0}
                            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
                        />
                    </div>
                    <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex'>
                        <CardsWidget7
                            className='flex-fill'
                            description='Lives Impacted'
                            icon={false}
                            stats={parseFloat((analyticsData?.lifeImpacted || 0).toFixed(2))}
                            labelColor='dark'
                            textColor='gray-300'
                        />
                    </div>
                    <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 d-flex'>
                        <CardsWidget18
                            className="flex-fill"
                            collectionValue={analyticsData?.completed?.toString() || "0"}
                            recyclingValue={analyticsData?.balance?.toString() || "0"}
                            collection={analyticsData?.collectVsRecyclePiechart?.RECYCLE || 0}
                            recycling={analyticsData?.collectVsRecyclePiechart?.COLLECT || 0}
                        />
                    </div>
                </div>

                <div className="row" style={{ marginTop: "30px" }}>
                    <div className="col-4">z
                        <MixedWidget10CS
                            className='card-xl-stretch mb-xl-8'
                            chartColor='info'
                            chartHeight='150px'
                            title="Commitment Created"
                            subtitle="Quantity collected from waste suppliers"
                            amount={analyticsData?.totalQuantity?.toString() || "0"}
                            chartData={analyticsData?.monthWiseCreated || {}}
                        />
                    </div>
                    <div className="col-4">
                        <MixedWidget10CS
                            className='card-xl-stretch mb-xl-8'
                            chartColor='warning'
                            chartHeight='150px'
                            title="Commitment Fullfilled"
                            subtitle="Quantity converted into recycled products"
                            amount={analyticsData?.completed?.toString() || "0"}
                            chartData={analyticsData?.monthWiseCompleted || {}}
                        />
                    </div>
                    <div className="col-4">
                        <ChartsWidgetG2
                            className="mb-5"
                            label=""
                            data={analyticsData?.enviournmentWisePiechart || { category1: 100, category2: 200, category3: 150 }}
                        />
                    </div>
                </div>
                <TablesWidget9 className='' data={analyticsData || {}} />
            </div> */}
            {/* <UsersListHeader label='Add new' placeholder='Search' /> */}

            <div style={{ marginLeft: "25px", marginTop: "20px", display: 'flex', gap: '12px', alignItems: 'flex-start', flexWrap: 'wrap' }}>

                <div style={{ minWidth: '25%' }}>
                    <MetricCards
                        cards={[
                            {
                                icon: <ProjectsIcon />,
                                value: analyticsData?.totalSponsors?.toString() || '0',
                                label: 'Impact Partners',
                            },
                            {
                                icon: <ChartIcon />,
                                value: analyticsData?.activeSponsors?.toString() || '0',
                                label: 'Active',
                            },
                            {
                                icon: <StockIcon />,
                                value: analyticsData?.totalMembershipTiers?.toString() || '0',
                                label: 'Tiers',
                            },
                            {
                                icon: <LocationIcon />,
                                value: analyticsData?.totalPickupPointsUnderSponsorship?.toString() || '0',
                                label: 'Hubs covered',
                                change: analyticsData?.pickupPointCoveragePercentage
                            },
                            {
                                icon: <PercentIcon />,
                                value: analyticsData?.totalCustomersUnderSponsorship?.toString() || '0',
                                label: 'Households',
                                change: analyticsData?.customerCoveragePercentage
                            },
                            {
                                icon: <SaveIcon />,
                                value: analyticsData?.totalPlasticPrevented?.toFixed(2).toString() || '0',
                                label: 'Plastic prevented',
                                change: analyticsData?.plasticPreventedPercentage
                            }
                        ]}
                    />
                </div>
                <div style={{ minWidth: '25%' }}>
                    <ChartsWidget14
                        className="mb-5"
                        // label="Sponsors by Tier"
                        data={analyticsData?.sponsorsPerMembershipTier}
                    />

                </div>
                <div style={{ minWidth: '25%' }}>
                    <ListsWidget2 data={analyticsData?.topSponsors || {}} className='card-xl-stretch ' title="Top 5 Impact Partners" />
                </div>
            </div>


            {/* 
            <div className="row" style={{margin:"10px 10px"}}>
                <div className="col-4">
                    <MixedWidget103
                        className='card-xl-stretch mb-xl-8'
                        chartColor='info'
                        chartHeight='150px'
                        title="Sponsored Hubs"
                        subtitle="Quantity collected from waste suppliers"
                        amount={`${analyticsData?.totalPickupPointsUnderSponsorship?.toString() || '0'}`}
                        chartData={analyticsData?.pickupPointGrowth || {}}
                    />
                </div>
                <div className="col-4">
                    <MixedWidget103
                        className='card-xl-stretch mb-xl-8'
                        chartColor='warning'
                        chartHeight='150px'
                        title="Sponsored Households"
                        subtitle="Quantity converted into recycled products"
                        amount={`${analyticsData?.totalCustomersUnderSponsorship?.toString() || '0'}`}
                        chartData={analyticsData?.customerGrowth || {}}
                    />
                </div>
                <div className="col-4">
                    <MixedWidget103
                        className='card-xl-stretch mb-5 mb-xl-8'
                        chartColor='primary'
                        chartHeight='150px'
                        title="Sponsored Collection"
                        subtitle="Quantity converted into recycled products"
                        amount={`${analyticsData?.totalPlasticPrevented?.toFixed(2).toString() || '0'} `}
                        chartData={analyticsData?.plasticPreventedGrowth || {}}
                    />
                </div>
            </div> */}

            {currentUser?.userType !== "CLIENT_USER" && currentUser?.userType !== "CLIENT" && <div className="mb-5 text-start">
                <button
                    style={{ marginLeft: "25px", marginTop: "15px" }}
                    // className="btn"
                    className='btn btn-primary fw-bold px-6'
                    onClick={() => navigate('/apps/commitment/new')}
                >
                    +  Add new
                </button>
            </div>}

            <UsersTable columnProps={roleColumns} />
            <UserEditModal formName='CommitmentForm' />
        </KTCard>
    )
}

const CreateComit = () => (
    <QueryRequestProvider initialValue={{ initialApi: 'sponsorCommitments' }}>
        <QueryResponseProvider>
            <ListViewProvider>
                <QualityList />
            </ListViewProvider>
        </QueryResponseProvider>
    </QueryRequestProvider>
)

export { CreateComit }

